import { render } from "./ShowDocumentModal.vue?vue&type=template&id=4fd38d81&scoped=true&ts=true"
import script from "./ShowDocumentModal.vue?vue&type=script&lang=ts"
export * from "./ShowDocumentModal.vue?vue&type=script&lang=ts"

import "./ShowDocumentModal.vue?vue&type=style&index=0&id=4fd38d81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd38d81"]])

export default __exports__